/**
 * The public lookup path for a company access code.
 *
 * Codes are not guaranteed to be alphanumeric: the backend builds one from the
 * first three characters of the organisation's title, spaces and punctuation
 * included. Encode the code so a `#` or `?` stays part of the path, and trim
 * it so a code pasted with surrounding whitespace still matches.
 */
export const organizationByCodePath = (code: string): string =>
  `/organizations/organization/by-code/${encodeURIComponent(code.trim())}/`
